import type { CallHistoryFilter } from './callsApi';

/** Every calls query key in one place, so an invalidation can never miss one. */
export const CALL_KEYS = {
  all: ['calls'] as const,
  history: (filter: CallHistoryFilter) => ['calls', 'history', filter] as const,
  detail: (callId: string) => ['calls', 'detail', callId] as const,
  active: (exclude: string) => ['calls', 'active', exclude] as const,
  voicemail: () => ['calls', 'voicemail'] as const,
  settings: () => ['calls', 'settings'] as const,
  people: (query: string) => ['calls', 'people', query] as const,
} as const;

/**
 * DELIBERATELY NOT UNDER `CALL_KEYS.all`.
 *
 * The chat rail's resolver is the one query in this feature whose `queryFn`
 * body is a WRITE — `POST /conversations`, behind `rateLimit('send')`. Every
 * `invalidateQueries({ queryKey: CALL_KEYS.all })` (hang up, transfer, add
 * people, merge, escalate) matches by PREFIX and defaults to
 * `refetchType: 'active'`, which refetches a mounted query whatever its
 * `staleTime` says. Sitting under `['calls', …]` therefore spent the user's
 * message-send budget on call-control presses.
 *
 * Its own root, so no call-control invalidation can reach it. The rail is not
 * call state and never wants to be refetched because a call changed — what it
 * needs to stay fresh (the timeline, receipts, typing) is chat's own realtime
 * subscription, which `CallChatThread` owns.
 */
export const CALL_CHAT_KEYS = {
  conversation: (callId: string) => ['call-chat', 'conversation', callId] as const,
} as const;
